export enum SingpassAccess {
  Denied = 'denied',
  Error = 'error',
  Granted = 'granted',
  Pending = 'pending',
}
